import "./TextArea.css";

// Define the props that the Input component will accept
interface InputProps {
    label: string;
    id: string;
    placeholder?: string;
    name: string;
    required?: boolean;
    value?: string;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    rows?: number;
    cols?: number;

}

const TextArea: React.FC<InputProps> = ({ label, id, placeholder, required,rows, cols, name, value, onChange }) => {
    return (
        <div className="inputContainer">
            <label htmlFor={id} className="inputLabel">
                {label}
                {required && '*'}
            </label>

            <textarea
                id={id}
                className="formInput"
                placeholder={placeholder}
                required={required}
                rows={rows}
                cols={cols}
                name={name}
                value={value}
                // onChange={onChange}
                
            />
        </div>

    );
};

export default TextArea;